module.exports = __webpack_public_path__ + "static/detail-bg.0bce8da3.png";